import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-deffered-deeplink',
    open_url: '',
    is_open_url: 0,
    auto_open: 0,
    external_url: '',
    fallback_type: 0,
    enableUrl: false,
  },
  getters: {
    formItemData(state) {
      return {
        open_url: state.open_url,
        is_open_url: state.is_open_url,
        auto_open: state.auto_open,
        external_url: state.external_url,
        fallback_type: state.fallback_type,
      };
    },
  },
  mutations: {
    [types.UPDATE_PCD_OPEN_URL](state, data) {
      state.open_url = data;
    },
    // auto_open=2 标识 deffered-deeplink 的链接（app install 下用的）
    [types.UPDATE_PCD_DEFFERED_DEEPLINK_IS_OPEN_URL](state, data) {
      state.is_open_url = data;
      state.auto_open = +state.is_open_url === 1 ? 2 : 0;
    },
    // auto_open = 0 标识 deeplink （traffic,conversion 下用的）
    [types.UPDATE_PCD_DEEPLINK_IS_OPEN_URL](state, data) {
      state.is_open_url = data;
      state.auto_open = 0;
      // // deeplink 如果显示， fallback_type 默认选中1
      // // traffic-app下，fallback_type 可以修改， conversion-app 下，页面上不展示 fallback_type ，但是需要传1
      // if (+state.is_open_url === 1) {
      //   state.fallback_type = 1;
      // } else {
      //   state.external_url = '';
      //   state.fallback_type = 0;
      // }
    },
    [types.UPDATE_PCD_EXTERNAL_URL](state, data) {
      state.external_url = data;
    },
    [types.UPDATE_PCD_ENABLE_URL](state, data) {
      state.enableUrl = data;
    },
    [types.UPDATE_PCD_FALLBACK_TYPE](state, data) {
      state.fallback_type = data;
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const data = {
        open_url: formData.open_url,
        is_open_url: formData.is_open_url,
        auto_open: formData.auto_open,
        external_url: formData.external_url,
        fallback_type: formData.fallback_type,
      };
      // 在编辑、复制、use exist新建时，如果后端返回的创意名称是空的，则需要再次勾选checkbox
      // 使用setPcdAdByCreativeDetail方法时，会设置resetAutoName，其余情况默认false
      commit('update', data);
    },
  },
});
